import type { IssuesUpdatePayload } from '@atlassian/jira-bulk-operations-common/src/controllers/use-form-submit-state/types.tsx';
import {
	isOptimisticUpdateSupported,
	transformFieldForOptimisticUpdates,
} from '@atlassian/jira-business-fields/src/common/bulk-edit-transform/index.tsx';
import type { ListIssueField } from '@atlassian/jira-business-fields/src/common/types.tsx';
import type { BaseIssueNode } from '@atlassian/jira-business-list-handlers/src/controllers/list-cache/types.tsx';
import { ff } from '@atlassian/jira-feature-flagging';

export const transformData = (existingIssue: BaseIssueNode, data: IssuesUpdatePayload['data']) => {
	const optimisticUpdateFields: ListIssueField[] = [];

	return Object.keys(data).reduce((acc, fieldId) => {
		const accumulator = acc;

		const existingField = existingIssue.fields?.find((field) => field.fieldId === fieldId);

		if (existingField) {
			if (isOptimisticUpdateSupported(existingField.type)) {
				const fieldFormValue = data[existingField.fieldId];

				if (fieldFormValue === undefined) {
					return accumulator;
				}

				const transformedField = transformFieldForOptimisticUpdates(
					existingField.type,
					existingField,
					fieldFormValue,
				);

				if (transformedField !== undefined) accumulator.push(transformedField);
			} else if (ff('thor-3996-optimistic-update-fixes-for-parent-field_6zcxj')) {
				accumulator.push(existingField);
			}
		}

		return accumulator;
	}, optimisticUpdateFields);
};
